module.exports = __webpack_public_path__ + "static/media/incident_triangle_red.7f9a7716.svg";